import Phaser from 'phaser';
import './style.css';
import { gameConfig } from './game/config';
import { hardenShell } from './platform/desktop';
import { isDesktop, runtime, wantsTouchPad } from './platform/runtime';
import { mountTouchPad } from './platform/TouchPad';
import { bindDataHotReload } from './game/dataHotReload';
import { AuthOverlay } from './ui/AuthOverlay';
import { CreateOverlay } from './ui/CreateOverlay';
import { MapEditorOverlay } from './ui/MapEditorOverlay';
import { loadSettings } from './systems/Settings';
import { net } from './net/NetClient';
import { REG } from './scenes/BootScene';
import { SaveGame } from './systems/SaveGame';
import type { PlayerState } from './systems/PlayerState';

loadSettings();
document.documentElement.dataset.runtime = runtime();
if (wantsTouchPad()) document.documentElement.dataset.touch = '1';
hardenShell();
mountTouchPad();

AuthOverlay.bind();
CreateOverlay.bind();

const game = new Phaser.Game(gameConfig);
bindDataHotReload(game);
MapEditorOverlay.bind(game);

function currentState(): PlayerState | undefined {
  return game.registry.get(REG.state) as PlayerState | undefined;
}

/** 진행 상황을 저장하고 기록이 끝날 때까지 기다린다 */
async function persist(): Promise<void> {
  const state = currentState();
  if (state?.mapId) {
    const data = state.toJSON();
    SaveGame.save(data);
    if (net.connected) net.pushSave(data);
  }
  await SaveGame.flush();
}

// 창을 닫기 전에 진행 상황을 저장한다
window.addEventListener('beforeunload', () => {
  void persist();
});

// 데스크톱 앱에서는 창 닫기 요청을 가로채 저장을 끝낸 뒤 닫는다
if (isDesktop()) {
  void (async () => {
    try {
      const { getCurrentWindow } = await import('@tauri-apps/api/window');
      const win = getCurrentWindow();
      await win.onCloseRequested(async (event) => {
        event.preventDefault();
        await persist();
        await win.destroy();
      });
    } catch {
      /* 모바일 웹뷰는 데스크톱 창 닫기 훅이 없을 수 있다 */
    }
  })();
}

// 캔버스 밖을 클릭해도 키 입력이 유지되도록 포커스를 캔버스에 둔다
window.addEventListener('pointerdown', (ev) => {
  const t = ev.target as HTMLElement | null;
  if (t?.closest('#touch-pad')) return;
  if (t?.id === 'chat-input' || t?.id?.startsWith('auth-') || t?.id?.startsWith('friend-') || t?.id?.startsWith('char-') || t?.id?.startsWith('map-')) return;
  game.canvas?.focus();
});

// dev 빌드에서만 자동화 테스트(scripts/smoke-test.mjs)가 게임 상태를 들여다볼 수 있게 노출한다
if (import.meta.env.DEV) {
  (window as unknown as { __game: Phaser.Game }).__game = game;
}
